<template>
    <div class="container" style="direction: rtl">
        <div class="card">
            <div class="card-header">
                <h3 class="card-title">تخصیص دستگاه</h3>
            </div>
            <div class="card-body">
                <div id="AllocateDevice">
                    <div class="input-group" style="direction: rtl">
                        <span class="input-group-text" style="min-width: 100px">انتخاب دستگاه</span>
                        <input class="form-control" disabled v-model="DeviceType.Name" type="text"   aria-describedby="basic-addon1">
                        <CButton @click="DialogSelectDeviceType = true" color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px">انتخاب</CButton>
                    </div>
                    <br>
                    <div class="input-group" style="direction: rtl">
                        <span class="input-group-text" style="min-width: 100px">انتخاب خط</span>
                        <input class="form-control" disabled  v-model="Fleet.FleetName" type="text"   aria-describedby="basic-addon1">
                        <CButton @click="DialogSelectFleet = true" color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px">انتخاب</CButton>
                    </div>
                    <br>
                    <div class="input-group" style="direction: rtl">
                        <span class="input-group-text" style="min-width: 100px">کلمه عبور</span>
                        <input class="form-control" v-model="Password" type="text"   aria-describedby="basic-addon1">
                    </div>
                    <br>
                    <div class="input-group" style="direction: rtl">
                        <span class="input-group-text" style="min-width: 100px">IMEI</span>
                        <input class="form-control" disabled v-model="Device.IMEI" type="text"   aria-describedby="basic-addon1">
                        <CButton @click="DialogSearchIMEI = true" color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px">انتخاب</CButton>
                    </div>
                    <br>
                    
                    
                    <br>
                    
                </div>

            </div>
            <div class="card-footer">
                <div style="float: left">
                    <b-button variant="primary" style="float: left;margin-left: 10px" @click="AssignDevice">تخصیص</b-button>
                    <b-button variant="warning" style="float: left;margin-left: 10px">انصراف</b-button>
                </div>
            </div>
        </div>

        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'sm'"
                :show.sync="DialogSearchIMEI"
        >
            <div style="direction: rtl;text-align: right">
                <CRow>
                    <label>
                        IMEI
                    </label>
                    
                        <div class="input-group" style="direction: rtl">
                            <input class="form-control"  v-model="TextSearchIMEI" type="text"   aria-describedby="basic-addon1">
                            <CButton @click="SearchIMEI" color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px">جستجو</CButton>
                        </div>
                </CRow>
                <CRow>
                   
                    <CSelect label="وضعیت تعریف در خطوط"    :options="List"  :value="indexList"  @change="Change"  > </CSelect>
                </CRow>
                
                <br>
                <br>
                <div >
                    <select class="form-select"  size="10"    v-model="indexDevice">
                        <option v-for="(device,index) in $store.state.Device_GetLikeIMEI.RequestResponse" :value="index" v-text="device.IMEI" v-bind:key="index"></option>
                    </select>
                </div>
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; یافتن سریال دستگاه </h4>

            </template>
            <template #footer>
                <CButton @click="DialogSearchIMEI = false" color="danger">بستن</CButton>
                <CButton @click="SelectIMEI()" color="primary">&nbsp;&nbsp;  انتخاب</CButton>
            </template>
        </CModal>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'sm'"
                :show.sync="DialogSelectDeviceType"
        >
            <div style="direction: rtl;text-align: right">
                <div >
                    <select class="form-select"  size="10"    v-model="indexDeviceType">
                        <option v-for="(type,index) in $store.state.DeviceType_GetAll.RequestResponse" :value="type.TypeID" v-text="type.Name" :key="index+1000"></option>
                    </select>
                </div>
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; انتخاب نوع دستگاه </h4>

            </template>
            <template #footer>
                <CButton @click="DialogSelectDeviceType = false" color="danger">بستن</CButton>
                <CButton @click="SelectDeviceType()" color="primary">&nbsp;&nbsp;  انتخاب</CButton>
            </template>
        </CModal>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'sm'"
                :show.sync="DialogSelectFleet"
        >
            <div style="direction: rtl;text-align: right">
                <div class="input-group" style="direction: rtl">
                    <span class="input-group-text" style="min-width: 100px">خط </span>
                    <input class="form-control"  v-model="TextSearchFleet" type="text"   aria-describedby="basic-addon1">
                    <CButton @click="GetFleets" color="primary" style="border-bottom-left-radius: 2px;border-top-left-radius: 2px">جستجو</CButton>
                </div>
                <div >
                    <select class="form-select" v-if="DeviceTypes" size="10"    v-model="indexFleet">
                        <option v-for="(fleet,index) in $store.state.LikeFleets.RequestResponse" :value="index" v-text="fleet.FleetName" :key="index"></option>
                    </select>
                </div>
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; انتخاب خط </h4>

            </template>
            <template #footer>
                <CButton @click="DialogSelectFleet = false" color="danger">بستن</CButton>
                <CButton @click="SelectFleet()" color="primary">&nbsp;&nbsp;  انتخاب</CButton>
            </template>
        </CModal>


        <div class="toast fade show" v-if="Toast.show" role="alert" aria-live="assertive" aria-atomic="true"  style="position: fixed;bottom: 10px;left:10px;direction: rtl;text-align: right;z-index: 8000">
            <div class="toast-header" v-if="Toast.state ==='success'">
                <svg class="docs-placeholder-img rounded me-2" width="20" height="20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
                    <rect width="100%" height="100%" fill="green"></rect>
                </svg><strong class="me-auto" style="float: right;width: auto">{{Toast.title}}</strong>
            </div>
            <div v-else-if="Toast.state ==='error'" class="toast-header" >
                <svg class="docs-placeholder-img rounded me-2" width="20" height="20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" preserveAspectRatio="xMidYMid slice" focusable="false">
                    <rect width="100%" height="100%" fill="red"></rect>
                </svg><strong class="me-auto" style="float: right;width: auto">{{Toast.title}}</strong>
            </div>
            <div class="toast-body">{{Toast.message}}</div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios'
    import VueAxios from 'vue-axios'
    import Constant from './../../assets/Constants'
    Vue.use(VueAxios, axios)
    export default {
        name: "DeviceAllocation",
        data(){
            return {
                Toast:{
                    message:'',
                    title:"",
                    state:"",
                    duration:3000,
                    show:false,
                },
                User:null,
                Fleets: [],
                Devices: [],
                DeviceTypes: [],
                indexDeviceType:0,
                indexFleet:0,
                indexDevice:0,
                DeviceType:{Name:""},
                Fleet:{FleetName:""},
                Device:{IMEI:""},
                ItemSelect:-1,
                Types: [{value:4, text: 'X5'},{value:5, text: 'X5-MDT'}],
                Password:'',
                DeviceSelect:'',
                showSearch:false,
                TextSearchIMEI:'',
                TextSearchFleet:'',
                InputIMEI:'',
                DialogSelectDeviceType:false,
                DialogSelectFleet:false,
                DialogSearchIMEI:false,
                indexList:1,
                List:[
                    {value:0,label:'همه'},
                    {value:1,label:'آزاد'},
                    {value:2,label:'تعریف شده'},
                ]

            }
        },
        computed:{
            ReadDevice_AssignToFleet(){
                return this.$store.state.Device_AssignToFleet;
            }
        },
        watch:{
            ReadDevice_AssignToFleet(res){
                if(res.Status){
                    if(res.RequestResponse[0].Message==='Successfully!'){
                            this.Device={};
                        this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                    }
                    
                }
            }
        },
        mounted(){
            this.GetDeviceType();
        },
        methods:{
            Change(lo){
                this.indexList=lo.target.selectedIndex;
                console.log(lo.target.selectedIndex);
            },
            GetFleets(){
                this.$store.commit('Fleet_GetLikeName',{
                    Key:this.TextSearchFleet
                });
            },
            GetDeviceType(){
                this.$store.commit('DeviceType_GetAll');
                var that=this;
            
            },
            SearchIMEI(){
                this.$store.commit('Device_GetLikeIMEI',{
                    Key:this.TextSearchIMEI,
                    Type:this.DeviceType.TypeID,
                    Assign:this.indexList
                });
            
            },
            SelectDeviceType(){
                this.DeviceType=this.$store.state.DeviceType_GetAll.RequestResponse[this.indexDeviceType-1];
                this.DialogSelectDeviceType=false;
            },
            AssignDevice(){
                var timeNow=Vue.moment().format('YYYY_MM_DD_HH_mm_ss');
                this.$store.commit('Device_AssignToFleet',{
                    IMEI:this.Device.IMEI,
                    Password:this.Password,
                    FleetID:this.Fleet.FleetID,
                    CurrentTime:timeNow,
                    UserID:1,
                    Error:-1,
                });
            },
          SelectDevice(index)
          {
            this.ItemSelect=index;
            this.InputIMEI=this.Devices[index][0];
          },
            SelectFleet(index)
          {
              this.Fleet=this.$store.state.LikeFleets.RequestResponse[this.indexFleet];
              this.DialogSelectFleet=false;
          },
            SelectIMEI(index)
          {
              this.Device=this.$store.state.Device_GetLikeIMEI.RequestResponse[this.indexDevice];
              this.DialogSearchIMEI=false;
          },
        }
    }
</script>

<style scoped>

</style>